import { makeAutoObservable, runInAction } from 'mobx'
import Settings from '../components/settings'

export class ValidateAddToCartController {
	validation_data

	/**
	 * @type {ValidateAddToCartController}
	 */
	static getInstance() {
		if (!this.instance) {
			this.instance = new ValidateAddToCartController()
		}
		return this.instance
	}

	constructor() {
		makeAutoObservable(this)
	}

	async validate(moduleIds) {
		const validation = await this.validateAddToCart(moduleIds)
    runInAction(() => {
      this.validation_data = validation.validation_data
    })
		return validation.validation_data
	}

	/**
	 * @param {Array} moduleIds
	 * @return {Promise<{validation_data:{[id:string]:{data:{}}}}>}
	 */
	async validateAddToCart(moduleIds) {
    let url = Settings.getSetting('validate_add_to_cart_api_url', 'event-info')

    if (url === undefined) {
      url = Settings.getSetting('validate_add_to_cart_api_url', 'cart')
    }

		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ event_group_ids: moduleIds })
		}).then(response => response.json())
		return response
	}

	/**
	 * @return {{[id:string]:{errors:{[id:string]:string}}}}
	 */
	get validation() {
		return this.validation_data
	}
}
